import Settings from 'settings'

export const project = {
  name: 'project',
  request: {
    url: `${Settings.api}/projects/?slug=:id`,
    middleware: {
      // checkStore: store => store.location.payload.id === store.project.data[0].slug
    }
  },
  state: {
    data: [] // project needs an empty array, so we override default 'data' here
  },
}



// WEBPACK FOOTER //
// ./src/redux/models/project.js